import { render, staticRenderFns } from "./epidemicRegister.vue?vue&type=template&id=d127319e&scoped=true"
import script from "./epidemicRegister.vue?vue&type=script&lang=js"
export * from "./epidemicRegister.vue?vue&type=script&lang=js"
import style0 from "./epidemicRegister.vue?vue&type=style&index=0&id=d127319e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d127319e",
  null
  
)

export default component.exports